import { render, staticRenderFns } from "./BaitingInfo.vue?vue&type=template&id=63aaef21&"
import script from "./BaitingInfo.vue?vue&type=script&lang=js&"
export * from "./BaitingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaitingInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports